import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { ApiResponse } from './workspace/DTO/api-response.dto';
import {
  PrevalidacionAutorizacionCuentaPorPagarDTO,
  PrevalidacionAutorizacionCuentaPorPagarInputDTO,
} from './workspace/DTO/prevalidacion-autorizacion-cuenta-por-pagar.dto';
import { PrevalidacionRetencionRecibidaDTO } from './workspace/DTO/prevalidacion-retencion-recibida.dto';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  public breadcrumb = true;
  public fechaHoy: any;
  public LogingLoading = false;
  loading = false;
  master: any;
  public esMovil: boolean;
  public innerWidth: any;
  public innerHeight: any;
  public fechaCorte: any;
  public empresaServicio: boolean;
  public parametrizaciones: any = {};
  public empresaUrbanizaciones: boolean;
  public contabilidadIntegrada: boolean;
  public empresaEventos: boolean;
  public empresaTransporte: boolean;
  public fechaPlan: boolean;
  public esTablet = false;
  public empresa: string;
  public cuentaContable: any = {};
  public nombreCuenta = '';
  private ids: number[] = [];
  private idsGuias: number[] = [];
  private cotizacionFacturacionContext: {
    idCliente: number | null;
    idSucursal: number | null;
    idBodega: number | null;
    idUsuarioVendedor?: number | null;
    idPuntoEmision?: number | null;
    serie?: string | null;
    cliente?: any;
  } | null = null;
  public boolFacturandoCotizaciones;

  constructor(private http: HttpClient, private router: Router, private notifier: NotifierService) {
    this.cargarStorage();
  }
  dimensionPantalla() {
    this.fechaHoy = new Date();
    this.fechaHoy = this.fechaHoy.toLocaleDateString();
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    if (this.innerWidth < 1400) {
      this.esTablet = true;
      if (this.innerWidth < 700) {
        this.esMovil = true;
      }
    } else {
      this.esTablet = false;
      this.esMovil = false;
    }
  }

  cargarStorage() {
    if (localStorage.telmah) {
      this.master = JSON.parse(localStorage.telmah);
    
      this.empresa = this.master?.usuario?.ultimaEmpresa?.nombre;
      this.fechaCorte = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.fechaCorte;
      this.empresaServicio = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.empresaDeServiciosGenerales;

      this.parametrizaciones.manejoDeLotes = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.manejoDeLotes;
      this.parametrizaciones.manejoFechaCaducidad = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.manejoFechaCaducidad;
      this.contabilidadIntegrada = this.master?.usuario?.ultimaEmpresa?.parametrosContabilidad?.contabilidadIntegrada;
      this.empresaUrbanizaciones = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.empresaAdministracionDeUrbanizaciones;
      this.empresaEventos = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.empresaDeEventosSociales;
      this.empresaTransporte = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.empresaDeTransporte;
      this.fechaPlan = this.master?.usuario?.ultimaEmpresa?.parametrosGenerales?.fechaCorte;
      // this.validarfechaSuscripcion();
    }
  }

  guardarStorage(data: any) {
    this.master = data;
    localStorage.setItem('telmah', JSON.stringify(data));
  }

  /**
   * Refresca desde la base central el tipo de la empresa activa y sincroniza
   * el valor en memoria y localStorage para no depender del login anterior.
   */
  async refrescarTipoEmpresaActiva(): Promise<void> {
    const response: any = await this.getTipo('parametros-cuentas-por-pagar');
    if (!response?.[0]) return;

    const valor = response[1]?.empresaDeServiciosGenerales;
    const empresaServicio = valor === true || Number(valor) === 1;
    this.empresaServicio = empresaServicio;
    this.master.usuario.ultimaEmpresa.parametrosGenerales.empresaDeServiciosGenerales = empresaServicio;
    this.guardarStorage(this.master);
  }

  async validarfechaSuscripcion() {
    let date = new Date();
    let dateFin = this.fechaCorte.split('T')[0];
    var nuevaDateFin = dateFin.split('-').reverse().join('/');
    let dateHoy = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
    let dias = this.restaFechas(dateHoy, nuevaDateFin);

    if (dias > 0 && dias < 15) {
      Swal.fire({
        title: 'AVISO',
        text: 'Estimado usuario, se le recuerda que su suscripcion expira en ' + ' ' + dias + ' dias ',
        icon: 'warning',
        confirmButtonColor: '#343a40',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Entendido',
      }).then(async result => {
        this.validarfechaFirma();
      });
    }
    if (dias < 0) {
      console.log('expirado');
    }
  }

  async validarfechaFirma() {
    let date = new Date();
    let dateFin = this.fechaCorte.split('T')[0];
    var nuevaDateFin = dateFin.split('-').reverse().join('/');
    let dateHoy = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
    let dias = this.restaFechas(dateHoy, nuevaDateFin);
    if (dias < 3) {
      Swal.fire({
        title: 'AVISO',
        text: 'Estimado usuario, se le recuerda que su firma electronica expira en ' + ' ' + dias + ' dias ',
        icon: 'warning',
        confirmButtonColor: '#343a40',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Entendido',
      });
    }
  }

  restaFechas = function (f1, f2) {
    var aFecha1 = f1.split('/');
    var aFecha2 = f2.split('/');
    var fFecha1 = Date.UTC(aFecha1[2], aFecha1[1] - 1, aFecha1[0]);
    var fFecha2 = Date.UTC(aFecha2[2], aFecha2[1] - 1, aFecha2[0]);
    var dif = fFecha2 - fFecha1;
    var dias = Math.floor(dif / (1000 * 60 * 60 * 24));
    return dias;
  };

  tokenIsValid(status: number) {
    if (status === 401) {
      this.cerrarSesion();
      return false;
    }
    return true;
  }
  showAlert(message: string, type: any) {
    const notificationType = type === 'warn' ? 'warning' : type;
    this.notifier.notify(notificationType, message || 'Operacion completada');
  }

  async confirmarAccion(options: {
    titulo?: string;
    mensaje?: string;
    detalle?: string;
    textoConfirmar?: string;
    textoCancelar?: string;
    mostrarCancelar?: boolean;
    tipo?: 'danger' | 'warning' | 'info';
    icono?: 'trash' | 'warning' | 'info' | 'question' | 'calendar' | 'lock' | 'unlock' | 'check';
  }): Promise<boolean> {
    const tipo = options?.tipo || 'danger';
    const iconClass =
      tipo === 'danger'
        ? 'erp-confirm-icon-danger'
        : tipo === 'warning'
          ? 'erp-confirm-icon-warning'
          : 'erp-confirm-icon-info';

    const iconoKey = options?.icono || this.iconoPorDefectoSegunTipo(tipo);
    const iconoSvg = this.svgPorIcono(iconoKey);

    const mensaje = this.escapeHtml(options?.mensaje || 'Confirma que deseas continuar con esta accion.');
    const detalle = options?.detalle
      ? `<div class="erp-confirm-detail">${this.escapeHtml(options.detalle)}</div>`
      : '';

    const result = await Swal.fire({
      title: options?.titulo || 'Confirmar accion',
      html: `
        <div class="erp-confirm-content-row">
          <div class="erp-confirm-icon ${iconClass}">
            <svg class="erp-confirm-icon-svg" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              ${iconoSvg}
            </svg>
          </div>
          <div class="erp-confirm-copy">
            <div class="erp-confirm-message">${mensaje}</div>
            ${detalle}
          </div>
        </div>
      `,
      showCancelButton: options?.mostrarCancelar !== false,
      reverseButtons: true,
      focusCancel: options?.mostrarCancelar !== false,
      buttonsStyling: false,
      confirmButtonText: options?.textoConfirmar || 'Eliminar',
      cancelButtonText: options?.textoCancelar || 'Cancelar',
      customClass: {
        container: 'erp-confirm-container',
        popup: 'erp-confirm-popup',
        title: 'erp-confirm-title',
        htmlContainer: 'erp-confirm-html',
        actions: 'erp-confirm-actions',
        confirmButton: 'erp-confirm-action',
        cancelButton: 'erp-confirm-cancel',
      },
    });

    return !!result.isConfirmed;
  }

  private iconoPorDefectoSegunTipo(tipo: 'danger' | 'warning' | 'info'): string {
    if (tipo === 'warning') return 'warning';
    if (tipo === 'info') return 'info';
    return 'trash';
  }

  private svgPorIcono(key: string): string {
    const map: Record<string, string> = {
      trash: `
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
        <path d="M10 11v6"></path>
        <path d="M14 11v6"></path>
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>`,
      warning: `
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>`,
      info: `
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>`,
      question: `
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>`,
      calendar: `
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>`,
      lock: `
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>`,
      unlock: `
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>`,
      check: `
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>`,
    };
    return map[key] || map.trash;
  }

  private escapeHtml(value: string): string {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  cerrarSesion() {
    this.master = null;
    localStorage.removeItem('telmah');
    localStorage.removeItem('usuario');
    localStorage.removeItem('token');
    this.router.navigateByUrl('/login');
  }
  async cambiarEmpresa(empresa: number) {
    const Empresa = { empresaId: empresa };
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/empresas/cambiar`, Empresa, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              const data = { ...response.respuesta };
              this.guardarStorage(data);
              this.cargarStorage();
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'No se pudo cambiar de empresa';
                this.showAlert(mensaje, 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async cargarEmpresas() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/empresas`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error al logearse']);
        }
      );
    });
  }
  async cargarTablas() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/migracion-tablas`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error ']);
        }
      );
    });
  }
  async cargarDatosTablas(idTabla: string, idEmpresa: string) {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/migracion-tablas/${idTabla}/empresa/${idEmpresa}`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error ']);
        }
      );
    });
  }
  async cargarDatosMigrados(idTabla: string, data: any) {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/clientes/migracion-tablas/${idTabla}/migrar`, data, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          this.showAlert('No se pudo completar la migracion ', 'error');
          resolve([false, 'Error ']);
        }
      );
    });
  }
  async login(data: any) {
    this.loading = true;
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/login/cliente`, data).subscribe(
        (response: any) => {
          console.log(response);
          this.loading = false;
          const user = {
            ...response.respuesta,
            token: response.respuesta.token,
          };
          this.guardarStorage(user);
          this.cargarStorage();
          setTimeout(() => (this.LogingLoading = false), 1500);
          resolve([true, null]);
        },
        (error: any) => {
          this.loading = false;
          this.showAlert('Error en las credenciales', 'error');
          resolve([false, 'Error en las credenciales']);
        }
      );
    });
  }
  async getIdentificadoresEspeciales() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http
        .get(`${environment.apiUrl}/clientes/identificacion-especiales`, {
          headers,
        })
        .subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            resolve([false, 'Error']);
          }
        );
    });
  }
  async getCLientes() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/clientes`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }
  async getCodigoCLientes() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/clientes/codigo`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }

  async getCodigoCotizacion() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/cotizaciones/codigo`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }

  async getCodigoCuentaPorCobrar() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/cobro/codigo`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }

  async getModulos() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/permisos/1`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }

  async getClientePorId(id: any) {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/clientes/${id}`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }
  async getProductoById(id) {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/productos/${id}`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }

  async getProveedorPorId(id: number) {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/proveedores/${id}`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }
  async getEmpleadoPorId(id: number) {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/empleados/${id}`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }

  async getSucursales() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/sucursal-usuario/validas`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar sucursales', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getSucursalesTodas() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/sucursales`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar sucursales', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getSucursalesValidadas(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/sucursal-usuario/usuario/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar sucursales', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getParametrosRetencionesIva() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/parametros-retencion-iva`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar parametros', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getParametrosRetencionesFuente() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/parametros-retencion-fuente`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar parametros', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getFacturas(filtros?: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (filtros) {
        Object.keys(filtros).forEach(key => {
          const value = filtros[key];
          if (value !== null && value !== undefined && value !== '') {
            params = params.set(key, String(value));
          }
        });
      }
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/factura-ventas`, { headers, params }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              const mensaje = error?.error?.respuesta || 'Error al cargar facturas';
              this.showAlert(mensaje, 'error');
            }
            resolve([false, error?.error]);
          }
        );
      });
    }
  }

  async getCotizaciones(filtros?: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (filtros) {
        Object.keys(filtros).forEach(key => {
          const value = filtros[key];
          if (value !== null && value !== undefined && value !== '') {
            params = params.set(key, String(value));
          }
        });
      }
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/cotizaciones`, { headers, params }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              const mensaje = error?.error?.respuesta || 'Error al cargar cotizaciones';
              this.showAlert(mensaje, 'error');
            }
            resolve([false, error?.error]);
          }
        );
      });
    }
  }

  async getParametrosListados() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/parametros-listados`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar parametros de listados', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getBodegasxSucursal(id_sucursal: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/sucursales/${id_sucursal}/bodegas`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar bodegas', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getEmpleadosxSucursal(id_sucursal: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/sucursales/${id_sucursal}/empleados`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar empleados', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getEmpleados() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/empleados`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar empleados', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getPuntoemisionxSucursal(id_sucursal: string, idTipoDocumento = '1') {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      let params = new HttpParams();
      params = params.append('idSucursal', id_sucursal);
      params = params.append('idTipoDocumento', idTipoDocumento);

      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/sucursal-punto-emision-usuario/validas`, { headers, params }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar puntos de emision', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getFacturaxId(id_factura: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/factura-ventas/${id_factura}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar factura', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCotizacionById(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cotizaciones/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar cotizacion', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getRetencionxId(id_factura: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/factura-ventas/${id_factura}/retencion`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar retencion', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  // login() {
  //   setTimeout(() => (this.LogingLoading = false), 1500);

  async createClientes(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/clientes`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear clientes', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async createIndentificacionEspecial(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/identificacion-especiales`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert('Registro creado con exito', 'success');

            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear registro', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async createAnticipoClientes(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/anticipo-clientes`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Anticipo creado con exito', 'success');
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
              }
              this.showAlert('Error al crear anticipo', 'error');
              resolve([false]);
            }
          );
      });
    }
  }
  async createAnticipo(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/anticipo-proveedores`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Anticipo creado con exito', 'success');

              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear anticipo', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async crearFacturaRecurrente(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/facturacion-recurrente`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Factura recurrente creada con exito', 'success');
              resolve([true]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear clientes', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editarFacturaRecurrente(data: any, id: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/facturacion-recurrente/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Factura recurrente editada con exito', 'success');
              resolve([true]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al editar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createProducto(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/productos`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert(response.respuesta, 'success');
            resolve([true]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear clientes', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async editProducto(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/productos/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editAnticipo(id: number, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/anticipo-proveedores/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert('Anticipo editado con exito', 'success');
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async editAnticipoClientes(id: number, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/anticipo-clientes/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Anticipo editado con exito', 'success');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async enviarcorreo(data: any) {
    this.loading = true;
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/recuperacion`, data).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.msj]);
        },
        (error: any) => {
          this.loading = false;
          if (!this.tokenIsValid(error.status)) {
            this.showAlert('Error al crear enviar correo', 'success');
          }
          resolve([false]);
        }
      );
    });
  }
  async restaurarcontra(data: any) {
    this.loading = true;

    this.loading = true;
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/recuperacion/cambiar`, data).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.msj]);
        },
        (error: any) => {
          this.loading = false;
          if (!this.tokenIsValid(error.status)) {
            this.showAlert('Error al crear restaurar contrasena', 'success');
          }
          resolve([false]);
        }
      );
    });
  }
  async getAnticiposProveedores(
    idProveedor: any = null,
    opts: {
      page?: number;
      limit?: number;
      q?: string;
      fechaDesde?: string;
      fechaHasta?: string;
    } = {}
  ) {
    let params = new HttpParams();
    if (idProveedor) params = params.append('idProveedor', idProveedor);
    if (opts.page !== undefined) params = params.append('page', String(opts.page));
    if (opts.limit !== undefined) params = params.append('limit', String(opts.limit));
    if (opts.q) params = params.append('q', opts.q);
    if (opts.fechaDesde) params = params.append('fechaDesde', opts.fechaDesde);
    if (opts.fechaHasta) params = params.append('fechaHasta', opts.fechaHasta);
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-proveedores`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              // Semantica original: entrega response.respuesta.
              // En modo paginado sera { items, paginacion }; en legacy es array.
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al cargar anticipos';
                this.showAlert(mensaje, 'error');
              }
              resolve([false, error?.error]);
            }
          );
      });
    }
  }

  async getAnticiposProveedoresPago(idProveedor: any = null) {
    let params = new HttpParams();
    if (idProveedor) params = params.append('idProveedor', idProveedor);
    params = params.append('pago', 'true');
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-proveedores`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar anticipos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getAnticiposClientes(
    idCliente: any = null,
    opts: {
      page?: number;
      limit?: number;
      q?: string;
      fechaDesde?: string;
      fechaHasta?: string;
    } = {}
  ) {
    let params = new HttpParams();
    if (idCliente) params = params.append('idCliente', idCliente);
    if (opts.page !== undefined) params = params.append('page', String(opts.page));
    if (opts.limit !== undefined) params = params.append('limit', String(opts.limit));
    if (opts.q) params = params.append('q', opts.q);
    if (opts.fechaDesde) params = params.append('fechaDesde', opts.fechaDesde);
    if (opts.fechaHasta) params = params.append('fechaHasta', opts.fechaHasta);
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-clientes`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              // Se conserva la semantica original: entrega response.respuesta.
              // En modo paginado sera { items, paginacion }; en legacy es array.
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al cargar anticipos';
                this.showAlert(mensaje, 'error');
              }
              resolve([false, error?.error]);
            }
          );
      });
    }
  }

  async getAnticiposClientesCobro(idCliente: any = null) {
    let params = new HttpParams();
    if (idCliente) params = params.append('idCliente', idCliente);
    params = params.append('cobro', 'true');
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-clientes`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar anticipos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCiudades() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/ciudades-clientes`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar ciudades', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getProductos(bodega: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/bodegas/${bodega}/stock`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar ciudades', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getAllProductos(filtros?: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (filtros) {
        Object.keys(filtros).forEach(key => {
          const value = filtros[key];
          if (value !== null && value !== undefined && value !== '') {
            params = params.set(key, String(value));
          }
        });
      }
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/productos`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar productos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createFactura(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/factura-ventas`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear factura', 'error');
              }

              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }

  async createCotizacion(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/cotizaciones`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear cotizacion', 'error');
              }

              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }
  async createCobro(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/cobro`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cobrar cuenta', 'error');
              }

              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }
  async pagarCuenta(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/cuenta-pagar/pagar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al pagar cuenta', 'error');
              }

              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }
  async modifyFactura(id: number, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/factura-ventas/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar factura', 'error');
              }
              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }

  async modifyCotizacion(id: number, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/cotizaciones/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar cotizacion', 'error');
              }
              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }
  async recuperarFactura(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/factura-ventas/${id}/recuperar`, {}, { headers })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al recuperar factura', 'error');
              }
              resolve([false, error.error?.respuesta || 'Error al recuperar factura']);
            }
          );
      });
    }
  }

  async anularCotizacion(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/cotizaciones/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.router.navigateByUrl('/facturacionVentas/cotizacion-ventas-historico');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al anular factura', 'error');
              }
              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }
  async anularRetencion(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/factura-ventas/${id}/retencion`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al anular retencion', 'error');
              }
              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }

  downLoadFileP(data: any, type: string) {
    let blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'archivo.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downLoadFile(data: any, type: string, nombreArchivo: string = 'reporte') {
    let blob2 = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob2);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  downLoadFileXml(data: any, type: string, nombreArchivo: string = 'reporte') {
    let blob2 = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob2);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  async reporteFacturasEmitidas(data: any) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    this.http
      .post(`${environment.apiUrl}/clientes/factura-ventas/reporte-emitidas`, data, {
        responseType: 'arraybuffer',
        headers: headers,
      })
      .subscribe(
        (response: any) => {
          this.downLoadFile(response, 'application/pdf');
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirComprobante(id: number, tipo: string, nombreArchivo: string = 'reporte') {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    let params = new HttpParams();
    params = params.append('electronica', tipo);
    this.http
      .get(`${environment.apiUrl}/clientes/factura-ventas/${id}/imprimir`, {
        responseType: 'arraybuffer',
        headers: headers,
        params: params,
      })
      .subscribe(
        (response: any) => {
          if (tipo == 'xml') {
            this.downLoadFileXml(response, 'application/xml', nombreArchivo);
          } else {
            this.downLoadFile(response, 'application/pdf', nombreArchivo);
          }
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirCotizacion(id: number) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    this.http
      .get(`${environment.apiUrl}/clientes/cotizaciones/${id}/imprimir`, {
        responseType: 'arraybuffer',
        headers: headers,
      })
      .subscribe(
        (response: any) => {
          this.downLoadFile(response, 'application/pdf');
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  /**
   * Persiste la retencion recibida y presenta el motivo autoritativo devuelto
   * por el backend cuando la autorizacion cambia o deja de ser valida.
   */
  async createRetencion(data: any, idFactura: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/factura-ventas/${idFactura}/retencion`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert(error?.error?.respuesta || 'Error al crear retencion', 'error');
              }
              resolve([false, error?.error?.respuesta]);
            }
          );
      });
    }
  }

  /**
   * Consulta la validacion SRI de una retencion recibida sin activar el loading
   * global ni persistir datos; la factura aporta el contexto confiable del cliente.
   */
  async prevalidarRetencionRecibida(idFactura: number, data: any): Promise<[boolean, PrevalidacionRetencionRecibidaDTO | string]> {
    if (!this.master.apiKey) {
      this.router.navigateByUrl('/login');
      return [false, 'La sesion no esta disponible'];
    }

    const headers = new HttpHeaders({ token: this.master.apiKey });
    return new Promise(resolve => {
      this.http
        .post<ApiResponse<PrevalidacionRetencionRecibidaDTO>>(
          `${environment.apiUrl}/clientes/factura-ventas/${idFactura}/retencion/validar`,
          data,
          { headers }
        )
        .subscribe(
          response => resolve([true, response.respuesta]),
          error => resolve([false, error?.error?.respuesta || 'No se pudo validar la retencion'])
        );
    });
  }

  /**
   * Contrasta la autorizacion de un documento de proveedor sin guardarlo ni
   * activar el loading global; el backend resuelve RUC y codigo SRI del tenant.
   */
  async prevalidarAutorizacionCuentaPorPagar(
    data: PrevalidacionAutorizacionCuentaPorPagarInputDTO
  ): Promise<[boolean, PrevalidacionAutorizacionCuentaPorPagarDTO | string]> {
    if (!this.master.apiKey) {
      this.router.navigateByUrl('/login');
      return [false, 'La sesion no esta disponible'];
    }

    const headers = new HttpHeaders({ token: this.master.apiKey });
    return new Promise(resolve => {
      this.http
        .post<ApiResponse<PrevalidacionAutorizacionCuentaPorPagarDTO>>(
          `${environment.apiUrl}/clientes/cuenta-pagar/autorizacion/validar`,
          data,
          { headers }
        )
        .subscribe(
          response => resolve([true, response.respuesta]),
          error => resolve([false, error?.error?.respuesta || 'No se pudo validar la autorizacion'])
        );
    });
  }

  async actualizarAutorizacion(idFactura: any, ruta: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/${ruta}/${idFactura}/autorizar`, null, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al autorizar factura', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async actualizarAutorizacionLiquidacion(id: any, ruta: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/${ruta}/${id}/autorizar`, null, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al autorizar liquidacion', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getEstadisticasIniciales() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/estadisticas/valores`, { headers }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response.respuesta]);
        },
        (error: any) => {
          this.loading = false;
          resolve([false, 'Error']);
        }
      );
    });
  }
  async getEstadisticasVentasPorMes() {
    this.loading = true;
    const headers = new HttpHeaders({
      token: this.master.apiKey,
    });
    return new Promise(resolve => {
      this.http
        .get(`${environment.apiUrl}/clientes/estadisticas/graficos/mes`, {
          headers,
        })
        .subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            resolve([false, 'Error']);
          }
        );
    });
  }

  async getFacturaPorNumeroFactura(numero: string, idPuntoEmision: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      params = params.append('numeroFactura', numero);
      params = params.append('idPuntoEmision', idPuntoEmision.toString());
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/factura-ventas/consultar`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar factura', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getEmpresa_in() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/empresas-in`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar empresa', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getRegimenesContribuyenteWorkspace() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrlV2}/workspace/business/regimenes-contribuyente`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar regímenes de contribuyente', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  descargarFirma() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/parametros-documentos-electronicos/descargar-firma`, {
            headers: headers,
            responseType: 'blob',
          })
          .subscribe(
            (response: any) => {
              this.downLoadFile(response, 'application/p12');
              this.showAlert('Firma descargada correctamente', 'success');
            },
            (error: any) => {
              this.showAlert('Error al descargar firma', 'error');
            }
          );
      });
    }
  }
  desacargarArchivosFacturas(data, filtroFecha: any = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();

      if (filtroFecha) {
        params = params.append('fechaInicio', filtroFecha.desde);
        params = params.append('fechaFin', filtroFecha.hasta);
      }
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/subida-facturas/descargar-documentos`, data, {
            headers,
            responseType: 'blob',
            params,
          })
          .subscribe(
            (response: any) => {
              saveAs(response, `${moment()}.zip`);

              resolve([true]);
              this.loading = false;
            },
            (error: any) => {
              console.log(error);
              this.loading = false;
              this.showAlert('error', 'error');
              resolve([false]);
            }
          );
      });
    }
  }
  enviarArchivosRetenciones(data) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/subida-retenciones/listar-documentos`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              resolve([true, response.respuesta]);
              this.loading = false;
            },
            (error: any) => {
              this.loading = false;
              this.showAlert('error', 'error');
              resolve([false]);
            }
          );
      });
    }
  }
  subirFirma(data) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/parametros-documentos-electronicos/subir-firma`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.showAlert('Firma cargada correctamente', 'success');

              resolve([true, response.respuesta]);
              this.loading = false;
            },
            (error: any) => {
              this.loading = false;
              resolve([false]);
            }
          );
      });
    }
  }
  enviarArchivosFacturas(data) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/subida-facturas/listar-documentos`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              resolve([true, response.respuesta]);
              this.loading = false;
            },
            (error: any) => {
              this.loading = false;
              this.showAlert(error?.error?.respuesta || 'Error al subir documento', 'error');
              resolve([false]);
            }
          );
      });
    }
  }

  async updateEmpresa(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(
            `${environment.apiUrl}/clientes/empresas-in`,
            data,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar empresa', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async updateSucursal(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/sucursales/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createSucursal(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/sucursales`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteSucursal(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/sucursales/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async activarSucursal(id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/sucursales/${id}/activar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async activarItem(ruta: string, id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/${ruta}/${id}/activar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al activar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async desactivarItem(ruta: string, id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/${ruta}/${id}/desactivar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar ', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async desactivarSucursal(id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      console.log(this.master.apiKey);
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/sucursales/${id}/desactivar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar sucursak', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editarPES(id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/puntos-emision-secuencias/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async activarPES(id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/puntos-emision-secuencias/${id}/activar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async desactivarPES(id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      console.log(this.master.apiKey);
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/puntos-emision-secuencias/${id}/desactivar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar sucursak', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteAnticipoC(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/anticipo-clientes/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Anticipo eliminado con exito', 'success');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar anticipo', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteAnticipo(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/anticipo-proveedores/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Anticipo eliminado con exito', 'success');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar anticipo', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getPuntosEmision() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/puntos-emision`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getSucursalesUsuario() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/sucursal-usuario`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getPuntosEmisionSecuencialFisicos() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/puntos-emision-secuencias/fisicos`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getPuntosEmisionSecuencial() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/puntos-emision-secuencias`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getAutorizaciones() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/puntos-emision-autorizacion`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getTipoCategorias() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/tipo-categoria`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getTipoDocumento() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/tipo-documentos`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getTipoDocumentoValidados(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/sucursal-tipo-documento-usuario/sucursal/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getPuntosEmisionValidados(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/sucursal-punto-emision-usuario/puntos-emision/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async procesarLoteRetenciones(retenciones: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(
            `${environment.apiUrl}/clientes/subida-retenciones/procesar-retenciones`,
            retenciones,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              const resultado = response.respuesta;
              this.showAlert(
                resultado.mensaje,
                resultado.noProcesadas > 0 ? 'warning' : 'success'
              );

              resolve([true, resultado]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              this.showAlert('Error al cargar documentos', 'error');
              resolve([false]);
            }
          );
      });
    }
  }
  async procesarFacturasRecurrentes(filtro, procesar: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      params = params.append('fechaCorte', filtro.fechaCorte);
      if (filtro.cliente != null && filtro.cliente !== 0) params = params.append('idCliente', filtro.cliente);
      if (filtro.grupo) params = params.append('idTipoGrupoRecurrente', filtro.grupo);

      return new Promise(resolve => {
        this.http
          .post(
            `${environment.apiUrl}/clientes/facturacion-recurrente/procesar`,
            procesar,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Facturas procesadas correctamente', 'success');

              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al procesar documentos', 'error');
              }
              this.showAlert('Error al procesar documentos', 'error');
              resolve([false]);
            }
          );
      });
    }
  }
  async procesarLote(facturas: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(
            `${environment.apiUrl}/clientes/subida-facturas/procesar-facturas`,
            facturas,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Lote cargado correctamente', 'success');

              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              this.showAlert('Error al cargar documentos', 'error');
              resolve([false]);
            }
          );
      });
    }
  }
  async listarRetenciones(filtroFecha: any = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (filtroFecha) {
        params = params.append('fechaInicio', filtroFecha.desde);
        params = params.append('fechaFin', filtroFecha.hasta);
      }

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/subida-retenciones/retenciones-por-subir`,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async listarFacturas(filtroFecha: any = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (filtroFecha) {
        params = params.append('fechaInicio', filtroFecha.desde);
        params = params.append('fechaFin', filtroFecha.hasta);
      }

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/subida-facturas/facturas-por-subir`,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async updatePuntoEmision(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/puntos-emision/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar punto Emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createPuntoEmision(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/puntos-emision`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createPuntoEmisionSecuencia(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/puntos-emision-secuencias`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createAutorizacion(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/puntos-emision-autorizacion`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async activePuntoEmision(id: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/puntos-emision/${id}/activar`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear sucursal', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteRetenciones(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/subida-retenciones/retenciones-listadas/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar retención', 'error');
              }
              this.showAlert('Error al eliminar retención', 'error');

              resolve([false]);
            }
          );
      });
    }
  }
  async deleteFactura(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/subida-facturas/facturas-listadas/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar factura', 'error');
              }
              this.showAlert('Error al eliminar factura', 'error');

              resolve([false]);
            }
          );
      });
    }
  }
  async deletePuntoEmision(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/puntos-emision/${id}/desactivar`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async activarPuntoEmision(id: number, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/puntos-emision/${id}/activar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async deleteAutorizaciones(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/puntos-emision-autorizacion/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async deletePuntoEmisionSecuencia(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/puntos-emision-secuencias/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async desactivarPuntoEmisionSecuencia(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/puntos-emision-secuencias/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al desactivar puntos de emision', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getPrevio(filtro: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      params = params.append('fechaCorte', filtro.fechaCorte);
      if (filtro.cliente != null && filtro.cliente !== 0) params = params.append('idCliente', filtro.cliente);
      if (filtro.grupo) params = params.append('idTipoGrupoRecurrente', filtro.grupo);

      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/facturacion-recurrente`,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  //
  async getItemAdmin(ruta: string, params?: HttpParams) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/admin/${ruta}`,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getTipoParametro(ruta: string, nombreParametro: any, valorParametro: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      let params = new HttpParams();
      params = params.append(nombreParametro, valorParametro);
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/${ruta}`,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getTipo(ruta: string, params?: HttpParams) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(
            `${environment.apiUrl}/clientes/${ruta}`,

            {
              headers,
              params,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async updateTipo(ruta: string, data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/${ruta}/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al modificar registro';
                this.showAlert(mensaje, 'error');
              }
              resolve([false, error?.error?.respuesta]);
            }
          );
      });
    }
  }
  async updateTipoA(ruta: string, data?: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/${ruta}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar registro', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async updateParametro(ruta: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/${ruta}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar registro', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async updateSeteos(ruta: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/${ruta}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar registro', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createTipo(ruta: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/${ruta}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al crear registro';
                this.showAlert(mensaje, 'error');
              }

              resolve([false, error?.error?.respuesta]);
            }
          );
      });
    }
  }
  async createTipoA(ruta: string, item: any) {
    item.estado = 'AUTORIZANDO...';
    if (!this.master.apiKey) {
      this.router.navigateByUrl('/login');
    } else {
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/${ruta}`, null, {
            headers,
          })
          .subscribe(
            (response: any) => {
              item.estado = 'AUTORIZADO';
              this.showAlert('Autorizado exitosamente', 'success');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              item.estado = 'NO AUTORIZADO';
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear registro', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async deleteItem(ruta: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/${ruta}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar registro', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteTipo(ruta: string, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/${ruta}/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
              this.showAlert('Elmiminado exitosamente', 'success');
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar registro', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createEmpleado(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/empleados`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              console.log(error);
              this.showAlert(error.error.respuesta, 'error');
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear empleado', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async updateEmpleado(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/empleados/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar cliente', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async updateCLiente(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/clientes/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar empleado', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async updateProveedor(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/proveedores/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar proveedor', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createCliente(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/clientes`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear cliente', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async createProveedor(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/proveedores`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              console.log(error);
              this.showAlert(error.error.respuesta, 'error');
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear proveedor', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteCliente(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/clientes/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar clientes', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteEmpleado(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/empleados/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar clientes', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteProveedor(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/proveedores/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              this.showAlert('Error al eliminar proveedor', 'error');

              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar proveedor', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  // crud grupo contable - cliente
  async getGruposContablesClientes() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/grupo-cliente-contable/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createGruposContablesClientes(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/grupo-cliente-contable/`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear grupos contable cliente', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async editGruposContablesClientes(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/grupo-cliente-contable/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar GruposContablesClientes', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deleteGruposContablesClientes(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/grupo-cliente-contable/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert('Grupo eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar grupo contable cliente', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async getGruposContablesProveedor() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/grupo-proveedor-contable/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createGruposContablesProveedor(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/grupo-proveedor-contable/`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear grupos contable cliente', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async editGruposContablesProveedor(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/grupo-proveedor-contable/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar GruposContablesClientes', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deleteGruposContablesProveedor(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/grupo-proveedor-contable/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert('Grupo eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar grupo contable cliente', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async getCuentas() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/plan-cuenta/cuentas/quinto`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasC() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      let params = new HttpParams();
      params = params.append('naturaleza', 'C');
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/plan-cuenta/cuentas`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getPlanCuentas() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/plan-cuenta`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async editPlanCuentas(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/plan-cuenta/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async deletePlanDeCuentas(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/plan-cuenta/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Eliminado correctamente', 'success');
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async addCuenta(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/plan-cuenta`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert(response.respuesta, 'success');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.showAlert(error.error.respuesta, 'error');

              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear cuenta', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasD() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      let params = new HttpParams();
      params = params.append('naturaleza', 'D');
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/plan-cuenta/cuentas`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getcomprobantesContables() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/tipo-comprobante-contable/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createcomprobantesContables(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/tipo-comprobante-contable/`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear tipo comprobante contable', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async editcomprobantesContables(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/tipo-comprobante-contable/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar tipo comprobante contable', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deletecomprobantesContables(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/tipo-comprobante-contable/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert('Comprobante contable eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar comprobante contable ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  //retenciones fte
  async getRetencionesFte() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/retencion-fuente`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async createRetencionFte(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/retencion-fuente`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear configuraacion', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  // retenciones iva
  async getRetencionesIva() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/retencion-iva`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async createRetencionIva(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/retencion-iva`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear configurcion', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getnivelesPrecios() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/producto-nivel-precio/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createnivelesPrecios(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/producto-nivel-precio/`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear nivel precio', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editnivelesPrecios(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/producto-nivel-precio/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar nivel precio', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deletenivelesPrecios(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/producto-nivel-precio/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert('Nivel precio eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar nivel precio ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async getformasPago() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/tipo-forma-pago`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getCodigoAnticipo() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-clientes/codigo`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;

              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getCodigoAnticipoP() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-proveedores/codigo`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;

              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getAnticipoxId(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-clientes/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Cargado con exito', 'success');
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getAnticipoPxId(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/anticipo-proveedores/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Cargado con exito', 'success');
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createformasPago(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/tipo-forma-pago/`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear forma de pago', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editformasPago(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/tipo-forma-pago/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al editar forma de pago', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteformasPago(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/tipo-forma-pago/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Forma de pago eliminado correctamente', 'success');
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar forma de pago ', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  // crud bancos

  async getbancos() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/cuenta-bancarias/`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async createbancos(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/cuenta-bancarias/`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear ', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editbancos(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/cuenta-bancarias/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al editar ', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deletebancos(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/cuenta-bancarias/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert(' Eliminado correctamente', 'success');
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al eliminar ', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async editsas(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/identificacion-especiales/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
            this.showAlert('Actualizado exitosamente ', 'success');
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deletesas(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/identificacion-especiales/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert(' Eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar ', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  // crud notas de credito

  async getnotascredito(
    idProveedor: any = null,
    pago: any = null,
    opts: {
      page?: number;
      limit?: number;
      q?: string;
      fechaDesde?: string;
      fechaHasta?: string;
    } = {}
  ) {
    let params = new HttpParams();
    if (idProveedor) params = params.append('idProveedor', idProveedor);
    if (pago) params = params.append('pago', 'true');
    // Paginacion opcional: si viene page el backend responde
    // { items, paginacion }; sino array plano legacy.
    if (opts.page !== undefined) params = params.append('page', String(opts.page));
    if (opts.limit !== undefined) params = params.append('limit', String(opts.limit));
    if (opts.q) params = params.append('q', opts.q);
    if (opts.fechaDesde) params = params.append('fechaDesde', opts.fechaDesde);
    if (opts.fechaHasta) params = params.append('fechaHasta', opts.fechaHasta);
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/nota-credito-proveedores`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al cargar';
                this.showAlert(mensaje, 'error');
              }
              resolve([false, error?.error]);
            }
          );
      });
    }
  }
  async getnotascreditopago(idProveedor: any = null) {
    let params = new HttpParams();
    if (idProveedor) params = params.append('idProveedor', idProveedor);
    params = params.append('pago', 'true');
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/nota-credito-proveedores`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getFechas() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/fechas-avisos`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async createnotascredito(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/nota-credito-proveedores`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async editnotascredito(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/nota-credito-proveedores/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deletenotascredito(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/nota-credito-proveedores/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert(' Eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  //nota de credito clientes

  async getnotascreditocliente(
    idCliente: any = null,
    opts: {
      page?: number;
      limit?: number;
      q?: string;
      fechaDesde?: string;
      fechaHasta?: string;
    } = {}
  ) {
    let params = new HttpParams();
    if (idCliente) params = params.append('idCliente', idCliente);
    // Paginacion opcional: si viene page el backend responde
    // { items, paginacion }; sino array plano legacy.
    if (opts.page !== undefined) params = params.append('page', String(opts.page));
    if (opts.limit !== undefined) params = params.append('limit', String(opts.limit));
    if (opts.q) params = params.append('q', opts.q);
    if (opts.fechaDesde) params = params.append('fechaDesde', opts.fechaDesde);
    if (opts.fechaHasta) params = params.append('fechaHasta', opts.fechaHasta);
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/nota-credito-clientes`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al cargar';
                this.showAlert(mensaje, 'error');
              }
              resolve([false, error?.error]);
            }
          );
      });
    }
  }

  async getnotascreditoclienteCobro(idCliente: any = null) {
    let params = new HttpParams();
    if (idCliente) params = params.append('idCliente', idCliente);
    params = params.append('cobro', 'true');
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/nota-credito-clientes`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createnotascreditocliente(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/nota-credito-clientes`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear ', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async editnotascreditocliente(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.put(`${environment.apiUrl}/clientes/nota-credito-clientes/${id}`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al editar ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async deletenotascreditocliente(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/nota-credito-clientes/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert(' Eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar ', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  // crud movimientos clientes

  //crud usuarios

  async createUsuarios(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.post(`${environment.apiUrl}/clientes/usuarios`, data, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al crear ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async editUsuarios(id: string, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/usuarios/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al editar ', 'success');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async deleteUsuarios(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.delete(`${environment.apiUrl}/clientes/usuarios/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            this.showAlert(' Eliminado correctamente', 'success');
            resolve([true, response.msj]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al eliminar ', 'success');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async desacivarUsuarios(id: any, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/usuarios/${id}/desactivar`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert(' Desactivado correctamente', 'success');
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async acivarUsuarios(id: any, data = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/usuarios/${id}/activar`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert(' Activado correctamente', 'success');
              resolve([true, response.msj]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasContablesB() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/plan-cuenta/cuentas/quinto`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasBancarias() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/tipo-cuenta-bancaria/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasExpired() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/tipo-cuenta-bancaria/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getEntidadesBancarias() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/tipo-entidad-bancaria/`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getUsuarios() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/usuarios`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async getPermisosxUsuario(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/permisos/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async editarPermisosxUsuario(id: number, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/permisos/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar asiento contable', 'error');
              }
              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }

  async getProveedores() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/proveedores`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response.respuesta]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  //asientos contables
  async getAsientos() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/asiento-contable`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar asientos contables', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async getAsientosFechas(filtros?: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (filtros) {
        Object.keys(filtros).forEach(key => {
          const value = filtros[key];
          if (value !== null && value !== undefined && value !== '') {
            params = params.set(key, String(value));
          }
        });
      }
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/asiento-contable`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                const mensaje = error?.error?.respuesta || 'Error al cargar asientos contables';
                this.showAlert(mensaje, 'error');
              }
              resolve([false, error?.error]);
            }
          );
      });
    }
  }

  async duplicarAsientoContable(id: any) {
    const headers = new HttpHeaders({ token: this.master.apiKey });
    return new Promise(resolve => {
      this.http
        .post(
          `${environment.apiUrl}/clientes/asiento-contable/${id}/duplicar`,
          {},
          { headers }
        )
        .subscribe(
          (response: any) => {
            resolve([true, response]);
          },
          (error: any) => {
            if (!this.tokenIsValid(error.status)) {
              const mensaje =
                error?.error?.respuesta || 'Error al duplicar el asiento contable';
              this.showAlert(mensaje, 'error');
            }
            resolve([false, error?.error]);
          }
        );
    });
  }

  async getAsientoxId(id_factura: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/asiento-contable/${id_factura}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar asiento contable', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async createAsiento(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/asiento-contable`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear asiento contable', 'error');
              }

              resolve([false]);
            }
          );
      });
    }
  }

  async modifyAsiento(id: number, data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/asiento-contable/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al modificar asiento contable', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async anularAsientoContable(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .delete(`${environment.apiUrl}/clientes/asiento-contable/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.router.navigateByUrl('/contabilidad/asientos-contables-historico');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al anular asiento contable', 'error');
              }
              resolve([false, error.error.respuesta]);
            }
          );
      });
    }
  }

  async getCuentasPorCobrar(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      let params = new HttpParams();
      params = params.append('idCliente', id);
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-cobrar-cuota`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  /**
   * GET /clientes/cuenta-cobrar/all
   * Espejo de getCuentasPorPagar: soporta filtros server-side y paginacion
   * opcional. Sin opts.page el backend responde array plano (backwards-compat).
   */
  async getCuentasPorCobrarAll(
    estado: string | null = 'PEN',
    opts: {
      page?: number;
      limit?: number;
      q?: string;
      fechaDesde?: string;
      fechaHasta?: string;
    } = {}
  ) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
      return;
    }
    let params = new HttpParams();
    if (estado) params = params.append('estado', estado);
    if (opts.page !== undefined) params = params.append('page', String(opts.page));
    if (opts.limit !== undefined) params = params.append('limit', String(opts.limit));
    if (opts.q) params = params.append('q', opts.q);
    if (opts.fechaDesde) params = params.append('fechaDesde', opts.fechaDesde);
    if (opts.fechaHasta) params = params.append('fechaHasta', opts.fechaHasta);
    const headers = new HttpHeaders({ token: this.master.apiKey });
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/clientes/cuenta-cobrar/all`, { headers, params }).subscribe(
        (response: any) => {
          this.loading = false;
          resolve([true, response]);
        },
        (error: any) => {
          this.loading = false;
          if (!this.tokenIsValid(error.status)) {
            const mensaje = error?.error?.respuesta || 'Error al cargar';
            this.showAlert(mensaje, 'error');
          }
          resolve([false, error?.error]);
        }
      );
    });
  }

  async getCuentasPorCobrarGeneralxId(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/cobro/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

    async getCuentasPorCobrarxComrpobante(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/cobro/codigo/${id}`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }

  async getCuentasPorPagarGeneralxId(id: string) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-pagar/pago/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
              this.showAlert('Cargado exitosamente ', 'success');
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasPorCobrarGlobal() {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http.get(`${environment.apiUrl}/clientes/cuenta-cobrar`, { headers }).subscribe(
          (response: any) => {
            this.loading = false;
            resolve([true, response]);
          },
          (error: any) => {
            this.loading = false;
            if (!this.tokenIsValid(error.status)) {
              this.showAlert('Error al cargar', 'error');
            }
            resolve([false]);
          }
        );
      });
    }
  }
  async getCuentasPorCobrarxId(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-cobrar/clientes/${id}`, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getCuentasPorPagar(
    id = null,
    estado: string | null = 'PEN',
    opts: {
      page?: number;
      limit?: number;
      q?: string;
      fechaDesde?: string;
      fechaHasta?: string;
    } = {}
  ) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      let params = new HttpParams();
      if (estado) {
        params = params.append('estado', estado);
      }
      if (id) {
        params = params.append('idProveedor', id);
      }
      // Paginacion opcional: si se pasa page el backend responde
      // { items, paginacion }; sino responde array plano legacy.
      if (opts.page !== undefined) {
        params = params.append('page', String(opts.page));
      }
      if (opts.limit !== undefined) {
        params = params.append('limit', String(opts.limit));
      }
      if (opts.q) {
        params = params.append('q', opts.q);
      }
      if (opts.fechaDesde) {
        params = params.append('fechaDesde', opts.fechaDesde);
      }
      if (opts.fechaHasta) {
        params = params.append('fechaHasta', opts.fechaHasta);
      }
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-pagar/all`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }
  async getCuentasPorPagarPorId(id) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      let params = new HttpParams();
      if (id) {
        params = params.append('idProveedor', id);
      }
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-pagar/${id}`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  /**
   * Crea la Cuenta por Pagar y conserva el mensaje de negocio del backend cuando
   * falla una validación del cruce transaccional con órdenes de compra.
   */
  async createCuentaPorPagar(data: any, masiva: any = null) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      let params = new HttpParams();
      if (masiva) params = params.append('masiva', masiva);
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/clientes/cuenta-pagar`, data, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert(
                  error?.error?.respuesta || 'Error al crear cuenta por pagar',
                  'error'
                );
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async editCuentaPorPagar(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/cuenta-pagar/${id}`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear cuenta por pagar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async editCuentaPorPagarRetencion(data: any, id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      data.idCuentaPorPagar = id;
      this.loading = true;
      console.log(data);
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .put(`${environment.apiUrl}/clientes/cuenta-pagar-retencion/cuenta/${id}`, data.retencion, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al crear cuenta por pagar', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  /**
   * Elimina la cuenta solicitada y presenta la regla de negocio exacta que el
   * backend devuelve cuando existe un documento relacionado.
   */
  async deleteCuentaPorPagar(id: number) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });

      return new Promise(resolve => {
        this.http
          .delete(
            `${environment.apiUrl}/clientes/cuenta-pagar/${id}`,

            {
              headers,
            }
          )
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Cuenta eliminada exitosamente ', 'success');

              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (this.tokenIsValid(error.status)) {
                this.showAlert(error?.error?.respuesta || 'Error al eliminar cuenta', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  /**
   * Consulta movimientos de proveedores con filtros de entidad, fechas y
   * número del documento asociado a la cuenta por pagar.
   */
  async getEstadoCuentaProveedores(
    proveedorIds: number[] = [],
    fechaInicio: any = '',
    fechaFin: any = '',
    numeroDocumento: string = ''
  ) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (proveedorIds && proveedorIds.length) {
        proveedorIds.forEach(id => { params = params.append('idProveedor', String(id)); });
      }
      if (fechaInicio) params = params.append('fechaInicio', fechaInicio);
      if (fechaFin) params = params.append('fechaFin', fechaFin);
      if (numeroDocumento.trim()) {
        params = params.set('numeroDocumento', numeroDocumento.trim());
      }
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-pagar/movimientos`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar factura', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  /**
   * Consulta los movimientos de clientes con filtros de entidad, fechas y
   * número del documento asociado a la cuenta por cobrar.
   */
  async getEstadoCuentaClientes(
    clienteIds: number[] = [],
    fechaInicio: any = '',
    fechaFin: any = '',
    numeroDocumento: string = ''
  ) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      if (clienteIds && clienteIds.length) {
        clienteIds.forEach(id => { params = params.append('idCliente', String(id)); });
      }
      if (fechaInicio) params = params.append('fechaInicio', fechaInicio);
      if (fechaFin) params = params.append('fechaFin', fechaFin);
      if (numeroDocumento.trim()) {
        params = params.set('numeroDocumento', numeroDocumento.trim());
      }
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/cuenta-cobrar/movimientos`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar factura', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async validarUsuario(data: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .post(`${environment.apiUrl}/admin/clientes/validar-usuario`, data, {
            headers,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  //reportes

  async descargarAts(
    ruta: any,
    opciones: { modalidad: string; anio: number; mes?: number; semestre?: number; visualizarVentasAts?: any }
  ) {
    const headers = new HttpHeaders({ token: this.master.apiKey });
    let params = new HttpParams();
    params = params.append('modalidad', opciones.modalidad);
    params = params.append('anio', String(opciones.anio));
    if (opciones.modalidad === 'mensual' && opciones.mes != null) {
      params = params.append('mes', String(opciones.mes));
    }
    if (opciones.modalidad === 'semestral' && opciones.semestre != null) {
      params = params.append('semestre', String(opciones.semestre));
    }
    if (opciones.visualizarVentasAts) {
      params = params.append('visualizarVentasAts', opciones.visualizarVentasAts);
    }
    const sufijo =
      opciones.modalidad === 'mensual'
        ? `${opciones.anio}-${String(opciones.mes).padStart(2, '0')}`
        : `${opciones.anio}-S${opciones.semestre}`;
    this.http
      .get(`${environment.apiUrl}/clientes/${ruta}`, {
        responseType: 'blob',
        headers: headers,
        params: params,
      })
      .subscribe(
        (response: any) => {
          this.downLoadFileXml(response, 'application/xml', `ats-${sufijo}`);
          this.showAlert('Ats descargado con exito', 'success');
        },
        (error: any) => {
          this.showAlert('Error al descargar reporte', 'error');
        }
      );
  }

  async imprimirComprobanteTipo(ruta: any) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    this.http
      .get(`${environment.apiUrl}/clientes/${ruta}`, {
        responseType: 'arraybuffer',
        headers: headers,
      })
      .subscribe(
        (response: any) => {
          this.downLoadFile(response, 'application/pdf');
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error al imprimir comprobante ', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirComprobanteX(id: number, contable? ) {
    this.loading = true;
    let params = new HttpParams();
    if (contable) params = params.append('contabilidad', contable);
    const headers = new HttpHeaders({ token: this.master.apiKey });
    this.http
      .get(`${environment.apiUrl}/clientes/cobro/print/${id}`, {
        responseType: 'arraybuffer',
        observe: 'response',
        headers: headers,
        params: params
      })
      .subscribe(
        (response: any) => {
          const contentDisposition = response.headers.get('content-disposition') || '';  // Fix for show pdf name sent from backend
          const filename = this.getFilenameFromCD(contentDisposition) || 'reporte.pdf';
          this.downLoadFile(response.body as ArrayBuffer, 'application/pdf', filename);

          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirComprobanteY(id: number, contable?) {
    this.loading = true;
    let params = new HttpParams();
    if (contable) params = params.append('contabilidad', contable);
    const headers = new HttpHeaders({ token: this.master.apiKey });
    this.http
      .get(`${environment.apiUrl}/clientes/pago/print/${id}`, {
        responseType: 'arraybuffer',
        observe: 'response',
        headers: headers,
        params: params
      })
      .subscribe(
        (response: any) => {
          const contentDisposition = response.headers.get('content-disposition') || ''; // Fix for show pdf name sent from backend
          const filename = this.getFilenameFromCD(contentDisposition) || 'reporte.pdf';
         
          this.downLoadFile(response.body as ArrayBuffer, 'application/pdf', filename);

          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  // Fix for show pdf name sent from backend
  private getFilenameFromCD(cd: string): string | null {
  // soporta filename*=UTF-8''... y filename="..."
    const match = /filename\*=(?:UTF-8'')?([^;]+)|filename="?([^"]+)"?/i.exec(cd);
    const raw = (match?.[1] || match?.[2] || '').trim();
    if (!raw) return null;
    try { return decodeURIComponent(raw); } catch { return raw; }
  }

  async imprimirComprobanteTipoFinal(ruta: any, tipo: string) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    let params = new HttpParams();
    params = params.append('electronica', tipo);
    this.http
      .get(`${environment.apiUrl}/clientes/${ruta}`, {
        responseType: 'arraybuffer',
        headers: headers,
        params: params,
      })
      .subscribe(
        (response: any) => {
          if (tipo == 'xml') {
            this.downLoadFileXml(response, 'application/xml');
          } else {
            this.downLoadFile(response, 'application/pdf');
          }
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirComprobanteRetencion(id: number, tipo: string) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    let params = new HttpParams();
    params = params.append('electronica', tipo);
    this.http
      .get(`${environment.apiUrl}/clientes/retencion-cuenta-pagar/${id}/pdf`, {
        responseType: 'arraybuffer',
        headers: headers,
        params: params,
      })
      .subscribe(
        (response: any) => {
          if (tipo == 'xml') {
            this.downLoadFileXml(response, 'application/xml');
          } else {
            this.downLoadFile(response, 'application/pdf');
          }
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirComprobanteNotaCredito(id: number, tipo: string) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    let params = new HttpParams();
    params = params.append('electronica', tipo);
    this.http
      .get(`${environment.apiUrl}/clientes/nota-credito-clientes/pdf/${id}`, {
        responseType: 'arraybuffer',
        headers: headers,
        params: params,
      })
      .subscribe(
        (response: any) => {
          if (tipo == 'xml') {
            this.downLoadFileXml(response, 'application/xml');
          } else {
            this.downLoadFile(response, 'application/pdf');
          }
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async imprimirComprobanteGuia(id: number, tipo: string) {
    this.loading = true;
    const headers = new HttpHeaders({ token: this.master.apiKey });
    let params = new HttpParams();
    params = params.append('comprobante', tipo);
    this.http
      .get(`${environment.apiUrl}/clientes/guia-remision/pdf/${id}`, {
        responseType: 'arraybuffer',
        headers: headers,
        params: params,
      })
      .subscribe(
        (response: any) => {
          if (tipo == 'xml') {
            this.downLoadFileXml(response, 'application/xml');
          } else {
            this.downLoadFile(response, 'application/pdf');
          }
          this.loading = false;
        },
        (error: any) => {
          this.showAlert('Error', 'error');
          this.loading = false;
        }
      );
  }

  async cargarFacturaRecurrente(idCliente: any, idTipoGrupoRecurrente: any) {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      let params = new HttpParams();
      params = params.append('idCliente', idCliente);
      params = params.append('idTipoGrupoRecurrente', idTipoGrupoRecurrente);
      const headers = new HttpHeaders({ token: this.master.apiKey });
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/facturacion-recurrente/detalles`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              this.showAlert('Factura recurrente cargada con exito', 'success');
              resolve([true, response.respuesta]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('No se encontro factura recurrente', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  async getGuiasRemision(isActivo = '', isAutorizado = '') {
    this.loading = true;
    if (!this.master.apiKey) {
      this.loading = false;
      this.router.navigateByUrl('/login');
    } else {
      this.loading = true;
      const headers = new HttpHeaders({ token: this.master.apiKey });
      let params = new HttpParams();
      params = params.append('isActivo', isActivo);
      params = params.append('estadoAutorizacion', isAutorizado);

      // params = params.append("fechaInicio", fechaInicio);
      // params = params.append("fechaFin", fechaFin);
      return new Promise(resolve => {
        this.http
          .get(`${environment.apiUrl}/clientes/guia-remision`, {
            headers,
            params,
          })
          .subscribe(
            (response: any) => {
              this.loading = false;
              resolve([true, response]);
            },
            (error: any) => {
              this.loading = false;
              if (!this.tokenIsValid(error.status)) {
                this.showAlert('Error al cargar documentos', 'error');
              }
              resolve([false]);
            }
          );
      });
    }
  }

  setIds(ids: number[]) {
    this.ids = ids;
  }

  getIds(): number[] {
    return this.ids;
  }

  setIdsGuias(ids: number[]) {
    this.idsGuias = ids;
  }

  getIdGuias(): number[] {
    return this.idsGuias;
  }

  setCotizacionFacturacionContext(context: {
    idCliente: number | null;
    idSucursal: number | null;
    idBodega: number | null;
    idUsuarioVendedor?: number | null;
    idPuntoEmision?: number | null;
    serie?: string | null;
    cliente?: any;
  } | null) {
    this.cotizacionFacturacionContext = context;
  }

  getCotizacionFacturacionContext() {
    return this.cotizacionFacturacionContext;
  }
}
